import { FC, useMemo } from 'react'
import { useStoreSelector } from 'helpers/reactReduxHelpers'
import { ProviderGroupItem, ProviderGroupItemComponent } from 'components/features/pageFilters/ProviderGroupItem/ProviderGroupItem'
import { providersSelector } from 'selectors/linkageSelectors'
import styles from 'components/features/pageFilters/FilterByAccountForm/FilterByAccountForm.styl'
import { activeManualAccountsSelector } from 'components/features/pageFilters/pageFilterSelectors'
import { AccountItemComponent } from 'components/features/pageFilters/AccountItem/AccountItem'
import Button from 'components/features/pfm/Button/Button'

type FilterByAccountFormProps = {
  onSelectAll?: () => void
  onClearSelection?: () => void
}
export const FilterByAccountForm: FC<FilterByAccountFormProps> = (props) => {
  const { onSelectAll, onClearSelection } = props

  const cids = useStoreSelector(providersSelector)

  const providersChild = useMemo(() => {
    return cids?.allKeys.map((pCid) => (
      <ProviderGroupItem cid={ pCid } key={ pCid } />
    ))
  }, [cids])

  const manualAccounts = useStoreSelector(activeManualAccountsSelector)
  const manualChild = useMemo(() => {
    if (!manualAccounts) {
      return null
    }

    const accounts = manualAccounts.map((account) => (
      <AccountItemComponent
        key={ account.uid }
        uid={ account.uid }
        title={ account.name }
      />
    ), [])

    if (accounts.length === 0) {
      return null
    }

    return (
      <ProviderGroupItemComponent
        title='Manually Linked'
      >
        { accounts }
      </ProviderGroupItemComponent>
    )

  }, [manualAccounts])

  const selectButtonChild = useMemo(() => {
    if (onSelectAll) {
      return (
        <Button
          style='textOnly'
          size='micro'
          onClick={ onSelectAll }
          className={ styles.selectAll }
          qaMarker='select-all'
        >
          Select All
        </Button>
      )
    }

    if (onClearSelection) {
      return (
        <Button
          style='textOnly'
          size='micro'
          onClick={ onClearSelection }
          className={ styles.selectAll }
          qaMarker='clear-all'
        >
          Clear All
        </Button>
      )
    }

    return null
  }, [onClearSelection, onSelectAll])

  return (
    <>
      { selectButtonChild }
      { providersChild }
      { manualChild }
      { selectButtonChild }
    </>
  )
}
